import React from 'react';
import UpdateIcon from '@material-ui/icons/Create';
import { withStyles } from '@material-ui/core/styles';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiCardMedia from '@material-ui/core/CardMedia';
import Card from '@material-ui/core/Card';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import IconButton from '../IconButton';
import Switch from '../Switch';
import { styles } from './ExpandablePanel.styles';
import { checkAccess } from '../../utils/admins';
import { mainColor, UNIT } from '../../constants/theme';
import copyIcon from '../../assets/pictures/copyIcon.svg';
import { checkIntegrationAccess, hasExternalIntegration } from 'src/utils/externalIntegration';
import { SPLASH, INGREDIENT } from '../../constants';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import { getCopyName } from '../../utils/product';
import { isStringNotNull } from 'src/utils/tools';
const Accordion = withStyles({
  root: {
    boxShadow: 'none',
    borderRadius: UNIT,
    touchAction: 'manipulation',
    backgroundColor: mainColor.colorMediumGray,
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    }
  },
  expanded: {
    margin: 'auto'
  }
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    borderBottom: '0.5px solid rgba(0,0,0,0)',
    backgroundColor: 'rgba(0,0,0,0)',
    minHeight: 40,
    width: '100%',
    '&$expanded': {
      minHeight: 40
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    },
    width: '100%',
    '& > :last-child': {
      paddingRight: 0
    }
  },
  expanded: {}
})(props => <MuiAccordionSummary {...props} />);

AccordionSummary.muiName = 'AccordionSummary';

const CardMedia = withStyles(() => ({
  root: {
    backgroundSize: 'conain',
    backgroundRepeat: 'no-repeat',
    margin: 0
  }
}))(MuiCardMedia);

const ExpandablePanel = props => {
  const {
    onUpdate,
    onRemove,
    onDuplicate,
    item,
    renderItems,
    onActivationChange,
    onExpand,
    expanded,
    isSection,
    handleProps,
    classes,
    isHighlighted,
    hasInfoIcon = false,
    onOpen,
  } = props;
  const { hidden, name, key = '', description, iconUrl, iconCompressedUrl, type = INGREDIENT } = item;
  const sectionClassName = isSection ? 'col-md ' : hasInfoIcon ? 'col-md-8 col-lg-8 col-xl-9 pl-md-5' : 'col-md-8 col-lg-9 col-xl-10 pl-md-5';
  const disabled = !isSection && hasExternalIntegration() === SPLASH && type === INGREDIENT
  return (
    <Accordion key={key.toString()} expanded={expanded} onChange={onExpand} square>
      <AccordionSummary
        className={classes.root}
        {...handleProps}
        style={{
          backgroundColor: isHighlighted ? 'rgba(0, 0, 0, 0.04)' : hidden && 'rgba(0, 0, 0, 0.2)',
          opacity: hidden && 0.7
        }}
      >
        <div className='row'>
          {isSection && (
            <div className='col-md flex-grow-0 d-flex flex-row justify-content-center align-items-center '>
              <Card className={classes.card}>
                {iconCompressedUrl || iconUrl ? (
                  <CardMedia className={classes.media} image={isStringNotNull(iconCompressedUrl) ? iconCompressedUrl : iconUrl} />
                ) : (
                  <div className='d-flex flex-column justify-content-center align-items-center'>
                    <AddAPhotoIcon className={classes.noImageIcon} />
                    <p className={classes.mediaStyle}>Ajouter une image</p>
                  </div>
                )}
              </Card>
            </div>
          )}
          <div
            className={`${sectionClassName} d-flex flex-column justify-content-center align-items-md-start align-items-center mt-2 mt-sm-0`}
          >
            <div className={classes.titleHeading}>
              {getCopyName(key, name)} <p className=' d-inline secondary-text'>{!isSection && `(${key})`}</p>
            </div>

            <div
              className='d-flex flex-column align-items-md-start align-items-center'
              style={{ fontSize: UNIT * 0.75 }}
            >
              {description}
            </div>
          </div>
          <div
            className={`col-md  ${(isSection || hasInfoIcon) ? 'col-xl-3' : 'col-xl-2 col-lg-3'} d-flex flex-column justify-content-center align-items-center pt-2 px-3`}
          >
            <div className='d-flex flex-row justify-content-around w-100 px-3'>
              {isSection && (
                <Switch
                  checked={!hidden}
                  onClick={e => e.stopPropagation()}
                  onChange={onActivationChange}
                />
              )}
              <IconButton
                className={classes.icon}
                disablePortal={false}
                title={`Modifier la ${isSection ? 'section' : 'liste'} ${name}`}
                disabled={!checkAccess('features', 'productAndOption')}
                onClick={e => {
                  e.stopPropagation();
                  onUpdate();
                }}
              >
                <UpdateIcon />
              </IconButton>
              <IconButton
                className={classes.icon}
                disablePortal={false}
                title={`Dupliquer la ${isSection ? 'section' : 'liste'} ${name}`}
                disabled={!checkAccess('features', 'productAndOption') || checkIntegrationAccess('expandablePanel', 'disableDuplication')}
                onClick={e => {
                  e.stopPropagation();
                  onDuplicate();
                }}
              >
                <img
                  src={copyIcon}
                  alt='displayimage'
                  className={classes.imageStyle}
                  style={{
                    opacity: (!checkAccess('features', 'productAndOption') || (checkIntegrationAccess('expandablePanel', 'disableDuplication'))) && 0.3
                  }}
                />
              </IconButton>
              {hasInfoIcon &&
                <IconButton
                  className={classes.icon}
                  disablePortal={false}
                  title='Informations'
                  onClick={e => {
                    onOpen();
                    e.stopPropagation();
                  }}
                >
                  <InfoOutlinedIcon />
                </IconButton>}
              <IconButton
                className={classes.icon}
                disablePortal={false}
                title={`Supprimer la ${isSection ? 'section' : 'liste'} ${name}`}
                disabled={!checkAccess('features', 'productAndOption') || checkIntegrationAccess('expandablePanel', 'disableDeletion') || disabled}
                onClick={e => {
                  e.stopPropagation();
                  onRemove();
                }}
              >
                <DeleteOutlinedIcon />
              </IconButton>
            </div>
          </div>
        </div>
      </AccordionSummary>
      {expanded && renderItems()}
    </Accordion>
  );
};
export default withStyles(styles)(ExpandablePanel);
